module.exports = __webpack_public_path__ + "static/4fc58a05-0668-40dc-858a-bab392aa412a-42c705d2daa7cff565ffcb422f4e9f5e.webp";